import TipoDocumentoCombobox from "./TipoDocumentoCombobox.vue";

export {TipoDocumentoCombobox}
export default TipoDocumentoCombobox
